'use client';

import { Mail, Phone, MessageCircle } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Card } from '@/components/ui/card';

export function ContactInfoCards() {
    const t = useTranslations('contactPage.infoCards');

    const contactInfo = [
        {
            icon: Mail,
            label: t('emailLabel'),
            value: t('emailValue'),
            link: `mailto:${t('emailValue')}`,
        },
        {
            icon: Phone,
            label: t('phoneLabel'),
            value: t('phoneValue'),
            link: `tel:${t('phoneValue').replace(/\s/g, '')}`,
        },
        {
            icon: MessageCircle,
            label: t('whatsappLabel'),
            value: t('whatsappValue'),
            link: `https://wa.me/${t('whatsappValue').replace(/[^0-9]/g, '')}`,
        },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {contactInfo.map((info, index) => {
                const Icon = info.icon;
                const isWhatsApp = info.label === t('whatsappLabel');
                const isEmail = info.label === t('emailLabel');

                // WhatsApp green: #25D366
                const iconColorClass = isWhatsApp
                    ? 'text-[#25D366]'
                    : isEmail
                        ? 'text-blue-600 dark:text-blue-400'
                        : 'text-primary-600 dark:text-primary-400';

                const bgColorClass = isWhatsApp
                    ? 'bg-[#25D366]/10 dark:bg-[#25D366]/20'
                    : isEmail
                        ? 'bg-blue-50 dark:bg-blue-900/20'
                        : 'bg-primary-50 dark:bg-primary-900/20';

                return (
                    <Card
                        key={index}
                        title={info.label}
                        description=""
                        showFooterLink={false}
                        className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800"
                        animationDelay={index * 100}
                        renderContent={
                            <div className="flex flex-col items-center text-center">
                                <div className={`mb-4 p-3 rounded-full ${bgColorClass}`}>
                                    <Icon className={`h-6 w-6 ${iconColorClass}`} />
                                </div>
                                <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">{info.label}</p>
                                {info.link ? (
                                    <a
                                        href={info.link}
                                        className="flex items-center gap-2 text-gray-900 dark:text-white font-medium hover:text-primary-600 dark:hover:text-primary-400 transition-colors justify-center"
                                        target={info.link.startsWith('http') ? '_blank' : undefined}
                                        rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                                    >
                                        {isEmail && <Mail className="h-4 w-4" />}
                                        {info.value}
                                    </a>
                                ) : (
                                    <p className="text-gray-900 dark:text-white font-medium">{info.value}</p>
                                )}
                            </div>
                        }
                    />
                );
            })}
        </div>
    );
}

